import React from 'react';
import { Group, Text, Textarea } from '@mantine/core';

interface NotesEditorProps {
  notes: string | null | undefined;
  onUpdateNotes: (notes: string | null) => void;
  disabled?: boolean;
}

export const NotesEditor: React.FC<NotesEditorProps> = ({
  notes,
  onUpdateNotes,
  disabled = false,
}) => {
  return (
      <Textarea
        value={notes || ''}
        onChange={(e) => onUpdateNotes(e.currentTarget.value || null)}
        minRows={4}
        autosize
        placeholder="Enter notes"
        disabled={disabled}
      />
  );
};
